import { request } from 'api/request';

import { NO_NOTIFICATION_ID } from 'pages/notifications/constants';
import type { NotificationFull } from 'pages/notifications/types';

import { QUERY_OPTIONS } from 'constants/queryConfig';

import type { ERROR_DATA } from '../type';
import { useQuery } from '@tanstack/react-query';

interface GetNotificationByIdParams {
    id: string | null;
}

const apiRequest = async (id: string | null): Promise<NotificationFull | undefined> => {
    if (!id || id === NO_NOTIFICATION_ID) {
        return;
    }
    return await request(`admin/release-notification/${id}`);
};

const useGetNotificationById = ({ id }: GetNotificationByIdParams) => {
    const queryFn = async (): Promise<NotificationFull | undefined> => {
        return await apiRequest(id);
    };

    return useQuery<NotificationFull | undefined, ERROR_DATA<unknown>>({
        queryKey: ['notifications', id],
        queryFn,
        enabled: Boolean(id) && id !== NO_NOTIFICATION_ID,
        ...QUERY_OPTIONS.USER_DATA,
    });
};

export { useGetNotificationById };
